import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  saveVersionInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Version/saveVersionInformation', data);
  }

  updateVersionInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Version/updateVersionInformation', data);
  }
  getAllVersionInformation(): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Version/getAllVersionInformation', '');
  }

  approveVersion(data: any): Observable<any> {
    return this.http.post<any[]>(this.baseUrl + 'Version/approveVersion', data);
  }
  getIsVersionRead(): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Version/isVersionRead', '');
  }
  deleteVersion(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}Version/deleteVersion`, data);
  }
  
  
}
